export default __webpack_public_path__ + "static/media/cabinet1-after-1024w.ecaa2e89.avif";